import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgWebcamEndSymbol = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 18,
	height: 18,
	viewBox: "0 0 18 18",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		clipPath: "url(#clip0_1422_6082)",
		children: [
			/* @__PURE__ */ _jsx("path", {
				d: "M8.54406 12.635C11.1831 12.635 13.3225 10.4956 13.3225 7.85656C13.3225 5.2175 11.1831 3.07812 8.54406 3.07812C5.905 3.07812 3.76562 5.2175 3.76562 7.85656C3.76562 10.4956 5.905 12.635 8.54406 12.635Z",
				stroke: "#BD0B0B",
				strokeLinecap: "round",
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M8.54367 9.97797C9.71659 9.97797 10.6674 9.02713 10.6674 7.85422C10.6674 6.6813 9.71659 5.73047 8.54367 5.73047C7.37076 5.73047 6.41992 6.6813 6.41992 7.85422C6.41992 9.02713 7.37076 9.97797 8.54367 9.97797Z",
				stroke: "#BD0B0B",
				strokeLinecap: "round",
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M8.54395 12.6328V14.7566",
				stroke: "#BD0B0B",
				strokeLinecap: "round",
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M2.17236 14.7578H14.9149",
				stroke: "#BD0B0B",
				strokeLinecap: "round",
				strokeLinejoin: "round"
			})
		]
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_1422_6082",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 16.99,
			height: 16.99,
			fill: "white",
			transform: "translate(0.0488281 0.953125)"
		})
	}) })]
});
export default SvgWebcamEndSymbol;
